
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';

import "rxjs/Rx";

import { environment } from '../../environments/environment';

import { Baseservice } from './baseservice'

import { AuthenticationService } from './authentication.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class GooglePlacesSearchService extends Baseservice {

  constructor(http: HttpClient, authentication: AuthenticationService) {
    super("google", http, authentication);
  }
  searchPlace(input) {
    return this.http.get(this.url + "/search/place?input=" + input);
  }
  searchPlaceDetails(placeid) {
    return this.http.get(this.url + "/search/place/details?placeid=" + placeid);
  }
}
